<template>
  <div>
    <md-field class="resize">
      <label for="email">Email</label>
      <md-input id="email" v-model="email" type="email" />
    </md-field>
    <md-field>
      <label for="password">Password</label>
      <md-input id="password" v-model="password[0]" type="password" />
    </md-field>
    <md-field>
      <label for="confirm">Confirm Password</label>
      <md-input id="confirm" v-model="password[1]" type="password" />
    </md-field>
    <md-button @click="createAccount">Create Account</md-button>
  </div>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  data() {
    return {
      email: '',
      password: ['', ''],
    };
  },
  methods: {
    async createAccount() {
      const auth = firebase.auth();
      if (this.password[0] !== this.password[1]) {
        // TODO: show better error
        console.error("Passwords don't match"); // eslint-disable-line
        return;
      }
      try {
        const userCredential = await auth.createUserWithEmailAndPassword(
          this.email,
          this.password[0]
        );
        console.log(userCredential); // eslint-disable-line
      } catch (error) {
        switch (error.code) {
          // TODO: fill these out
          case 'auth/email-already-in-use':
            break;
          case 'auth/invalid-email':
            break;
          case 'auth/weak-password':
            break;
          default:
            console.error(error); // eslint-disable-line
            break;
        }
      }
    },
  },
};
</script>

<style scoped>
.resize {
  margin-left: 50%;
  width: 150px;
  height: 50px;
}
</style>
